<script setup lang="ts">
import InputText from 'primevue/inputtext'

import type { RInputTextProps } from './RInputText.types.ts'

defineProps<RInputTextProps>()

const model = defineModel<string | null>()

const emit = defineEmits<{
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  input: [originalEvent: Event, value: any]
  onBlur: [originalEvent: Event]
}>()

const onInput = (event: Event) => {
  emit('input', event, model)
}
const onBlur = (event: Event) => {
  emit('onBlur', event)
}
</script>

<template>
  <InputText
    v-bind="$props"
    v-model="model"
    :unstyled="false"
    @input="onInput"
    @blur="onBlur"
  />
</template>

<style src="./RInputText.css"></style>
